import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStateFacade } from '@app-state';

import { Observable } from 'rxjs';
import {
    filter,
    map,
    startWith,
} from 'rxjs/operators';

@Component({
    templateUrl: './review-transactions.page.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewTransactionsPageComponent {
    public userId$: Observable<number>;

    constructor(
        private _route: ActivatedRoute,
        appState: AppStateFacade,
    ) {
        this.userId$ = this._route.paramMap.pipe(
            map(params => Number(params.get('id'))),
            filter(id => id > 0),
            startWith(appState.user.value!.id),
        );
    }
}
